import axios from 'axios';

const widgetHelper = require('@/scripts/widgetHelper');

function isMobile() {
    return window.matchMedia('only screen and (max-width: 1023px)').matches;
}

export default {
    state: {
        rewardsActionURLs: window.vue.actionURLs,
        rewards: {}
    },
    getters: {
        rewards(state) {
            return state.rewards;
        }
    },
    mutations: {
        setRewards(state, data) {
            state.rewards = data;
            if (window.vueCurrentActiveStates['rewards-page']) widgetHelper.spinner.stop();
        }
    },
    actions: {
        getRewards({ commit, state }) {
            const apiString = `${state.rewardsActionURLs['Cart-GetRewards']}`;

            return axios.get(apiString, { params: { basketType: window.vueCurrentActiveStates['rewards-page'] ? 'order' : 'cart' } })
                .then((response) => {
                    if (response.data.error) widgetHelper.createError(response.data.errorMessage || response.data.message);
                    else {
                        if (response.data.rewards) {
                            commit('setRewards', response.data.rewards);
                        }
                        if (window.vueCurrentActiveStates.cart && response.data.basket) {
                            commit('setCart', response.data.basket);
                        }
                        if (window.vueCurrentActiveStates['rewards-page']) {
                            if (response.data.basket) {
                                if (isMobile()) {
                                    window.EventEmitter?.emit('toast:show', {
                                        type: 'info',
                                        template: 'addToCartToast'
                                    });
                                }
                                window.EventEmitter?.emit('miniCart:update', response.data.basket);
                                document.dispatchEvent(new CustomEvent('update-cart', { detail: { order: response.data.basket } }));
                                if (response.data.customer && response.data.updateCheckout) {
                                    document.dispatchEvent(new CustomEvent('update-checkout-page', { detail: { order: response.data.basket, customer: response.data.customer, updateCheckout: response.data.updateCheckout } }));
                                }
                            }
                        }
                    }
                })
                .catch((error) => {
                    widgetHelper.createError(error.response.data.errorMessage || error.response.data.message);
                    widgetHelper.spinner.stop();
                });
        },

        getLoyalityDiscounts({ state, dispatch }, payload) {
            widgetHelper.spinner.start();
            const apiString = `${state.rewardsActionURLs['Cart-GetLoyaltyDiscounts']}`;

            return axios({
                method: 'post',
                url: apiString,
                data: payload,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(() => {
                    dispatch('getRewards');
                })
                .catch((error) => {
                    if (error.response) {
                        widgetHelper.createError(error.response.data.errorMessage || error.response.data.message);
                    }
                    widgetHelper.spinner.stop();
                });
        },

        removeLoyalityDiscounts({ state, dispatch }, payload) {
            widgetHelper.spinner.start();

            const apiString = `${state.rewardsActionURLs['Cart-RemoveLoyaltyDiscounts']}`;

            return axios({
                method: 'post',
                url: apiString,
                data: payload,
                headers: { 'Content-Type': 'multipart/form-data' }
            })
                .then(() => {
                    dispatch('getRewards');
                })
                .catch((error) => {
                    if (error.response) {
                        widgetHelper.createError(error.response.data.errorMessage || error.response.data.message);
                    }
                    widgetHelper.spinner.stop();
                });
        }
    }
};
